import React from "react";
import style from "./privacypolicy.module.css";

const PrivacyPolicy = () => {
  return (
    <div>
      <div className={style.privacyPolicyContainer}>
        <div className="container">
          <div className={style.mainprivacypolicyheading}>
            <div className={style.privacyHeading}>
              {" "}
              Privacy Policy
              <br />{" "}
              {/* <div className={style.subHeading}>
              {" "}
              Site Privacy Policy
            </div> */}
            </div>
          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>Effective Date: <span>February 1, 2026 </span></div>
            <div className={style.sectionsubheading}>
              FundLife.me (“FundLife,” “we,” “our,” or “us”) respects your privacy and is committed to handling personal information with care, dignity, and discretion. This Privacy Policy explains how information is collected, used, and shared when you use the FundLife.me website and related services (the “Services”).
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectioninnerHeading}>
              1. Information We Collect
            </div>
            <div className={style.sectioninnersubHeading}>
              Information You Provide
            </div>
            <div className={style.privacyText}>
              We collect information you voluntarily provide, which may include:
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                    IP address (used to determine general location like city or state)
                  </li>
                  <li>
                    Browser type, device type, and operating system
                  </li>
                  <li>
                    Pages visited and basic usage information
                  </li>
                </ul>


              </div>
              You control what information you choose to provide
            </div>

          </div>

          <div className="my-5">

            <div className={style.sectionHeading}>
              Information Collected Automatically
            </div>
            <div className={style.privacyText}>
              When you use the Services, limited technical information may be collected automatically, such as:
              <div className={style.privacytextlist}>
                <li>
                  <ul>
                    IP address (used to determine general location like city or state)
                  </ul>

                </li>
                <li>
                  <ul>
                    Browser type, device type, and operating system
                  </ul>

                </li>
                <li>
                  <ul>
                    Pages visited and basic usage information
                  </ul>
                </li>
              </div>
              This information is used to operate, secure, and improve the Services.
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
              2. Public and Non-Public Information
            </div>
            <div className={style.privacyText}>
              Fundraising pages and related content may be publicly visible by default. Any information you choose to post publicly may be viewed, shared, or copied by others. Please avoid sharing personal or sensitive information unless you intend for it to be public. 
              Non-public communications (such as messages sent to FundLife support) are treated as private and used only to provide assistance, maintain platform integrity, and enforce our policies. 
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
             3. Sensitive Information 
            </div>
            <div className={style.privacyText}>
              Some fundraising efforts may involve sensitive circumstances. You are responsible for the content you choose to share. Please do not submit sensitive personal information (such as medical details, information about minors, or government identification numbers) unless necessary and you have the authority to do so. 
              If you provide information about another person, you confirm that you have permission to share that information. 
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
         4. Donations and Payment Processing 
            </div>
            <div className={style.privacyText}>
              Donations made through FundLife.me are processed by third-party payment processors. FundLife does not store full payment card numbers or banking credentials. 
              Information collected directly by payment processors is governed by their own privacy policies. FundLife may receive limited transaction information necessary for recordkeeping, support, and responsible stewardship. 
            </div>
            <div className={style.sectionHeading}>
             5. How We Use Information 
           <div className={style.privacyText}>
             We use information to: 
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                   Operate and maintain the Services 
                  </li>
                  <li>
                    Provide user support and respond to inquiries 
                  </li>
                  <li>
                   Facilitate fundraising activities 
                  </li>
                   <li>
                  Protect against fraud, abuse, or misuse  
                  </li>
                   <li>
                   Comply with legal obligations  
                  </li>
                </ul>


              </div>
             FundLife does not sell or rent personal information. 
            </div>
            </div>
            <div className={style.sectionHeading}>
              6. How We Share Information 
                <div className={style.privacyText}>
              We may share information only in limited circumstances, including: 
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                   With service providers who assist in operating the Services (such as hosting, security, and payment processing), solely for those purposes 
                  </li>
                  <li>
                    When required by law or legal process 
                  </li>
                  <li>
                   To protect the rights, safety, or integrity of FundLife, its users, or the public
                  </li>
                </ul>


              </div>
              
            </div>
            </div>
            <div className={style.sectionHeading}>
          7. Cookies and Similar Technologies 
                <div className={style.privacyText}>
              FundLife may use cookies or similar technologies that are necessary for basic website functionality and performance. You may adjust your browser settings to limit cookies, but some features may not function properly. 
              
            </div>
            </div>
            <div className={style.sectionHeading}>
              8. Data Security 
                <div className={style.privacyText}>
             We take reasonable administrative and technical measures to safeguard information. While no system can guarantee absolute security, we work to protect information from unauthorized access or misuse. 
            </div>
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>9. Data Retention </div>
            <div className={style.privacyText}>
              We retain personal information only for as long as reasonably necessary to operate the Services, maintain records, comply with legal requirements, and enforce our policies.
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>10. Children’s Privacy  </div>
            <div className={style.privacyText}>
             FundLife.me is not intended for use by children under the age of 13, and we do not knowingly collect personal information from children under 13. 
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
             11. Your Choices 
            </div>
            <div className={style.privacyText}>
              You may request to update or correct your information, or ask questions about how your information is handled, by contacting us using the information below. 
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
              12. Changes to This Policy 
            </div>
            <div className={style.privacyText}>
              We may update this Privacy Policy from time to time. The Effective Date above reflects the most recent version. Continued use of the Services indicates acceptance of any updates. 
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>13. Contact Us  </div>
            <div className={style.privacyTextcontact}>
              <p>For privacy-related questions or requests: </p>
              <b>FundLife.me </b>
              <p>Email: info@Fundlife.me </p>
              <p>Houston, Texas </p>
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
              PUBLIC PLATFORM 
            </div>
            <div className={style.privacyText}>
             Some parts of HBCU Hope Project are public and can be viewed by anyone, even if they don’t have an account. When you submit information or content such as photos and videos to HBCU Hope Project to be posted on a public part of the Services, like fundraiser pages, forums or comment sections, that information and content may be visible to anyone, including public visitors and Users of our Services. The content and information may also appear in search results from search engines like Google. Please note that information you choose to share publicly is not
             subject to the same legal protections that apply to non-public personal data under certain data protection laws. We encourage you to consider what personal details you include in publicly available content. By using the Services and posting to public-facing portions of the Services, you are directing us to share certain information publicly and freely.  
            </div>

          </div>
        
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
